import React from 'react';

import { H5, P1 } from '../Title';

const mappedTypesComponents = {
  'header': {
    component: H5,
    styles: { lineHeight: '3.2rem',padding: '1.6rem 1rem', fontWeight: 'bold' }
  },
  'text': {
    component: P1,
    styles: { lineHeight: '1.6rem',padding: '1.6rem 1rem' }
  }
}

const getComponentFromKey = (subq, idnx) => {
  const typeComponent = mappedTypesComponents[subq[1]['type']];

  return (
    <typeComponent.component key={idnx} style={typeComponent.styles}>
      <strong>{subq[0]}</strong>
      :
      {' '}
      {subq[1]['content']}
    </typeComponent.component>
  )
}

const ChaveValorTyped = ({ data }) => {
  return (
  <>
    {data?.map((values, count) => (
      <>
      {Object.entries(values).map((subq, idnx) => getComponentFromKey(subq, idnx))}
      </>
    ))}
  </>)
}
;


export default ChaveValorTyped;
